import styles from './style.module.css';
import Modal from 'react-responsive-modal';
import { useAuth } from '../../../../hooks/useAuth';

interface IModalHasSucced {
  modalIsOpen: boolean;
  correctAnswers: number;
  earnedPoints: number;
  accuracyPercentage?: number;
  toggleModal: () => void;
}

export function ModalHasSucced({
  modalIsOpen,
  correctAnswers,
  earnedPoints,
  accuracyPercentage,
  toggleModal,
}: IModalHasSucced) {
  const { client } = useAuth();
  const coinLabel =
    earnedPoints === 1
      ? client?.coinName
        ? client.coinName.replace(/\(\w*\)/g, '')
        : 'ponto'
      : client?.coinName
        ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo)
        : 'pontos';

  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerSuccess}`}>
        <i className="material-icons-outlined">emoji_events</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.titleSuccess}>Parabéns, você pontuou! 🎉</h2>
        <p className={styles.detail}>
          Você acertou <strong>{accuracyPercentage}%</strong> das questões (
          {correctAnswers} pergunta{correctAnswers !== 1 && 's'} correta
          {correctAnswers !== 1 && 's'}).
        </p>
        <div className={styles.pointsBox}>
          <p>
            +{earnedPoints} {coinLabel} adicionados!
          </p>
        </div>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnSuccess}
          type="button"
        >
          Ver pontuação
        </button>
      </div>
    </Modal>
  );
}
